module.exports = __webpack_public_path__ + "static/media/exit-top.e721d0f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/exit-top.svg
// module id = 104
// module chunks = 0